module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "settings-wrapper"
  }, [_c('div', {}, [_c('strong', [_vm._v("Player name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playerName),
      expression: "playerName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "playerName"
    },
    domProps: {
      "value": (_vm.playerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.playerName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tile-colors"
  }, [_c('strong', [_vm._v("Tile color")]), _vm._v(" "), _c('div', {
    staticClass: "tiles"
  }, _vm._l((_vm.availableTileColors), function(tile) {
    return _c('Tile', {
      key: tile,
      class: {
        'selected': tile === _vm.selectedTileColor
      },
      attrs: {
        "disabled": tile === 'secret',
        "tile": {
          alive: true,
          health: 8
        },
        "color": tile
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectTileColor(tile)
        }
      }
    })
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d39c88","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 111
// module chunks = 1